import React from 'react';
import { ToastContainer } from 'react-toastify';
import HeroSection from 'components/PartnerPage/HeroSection';
import { EmailInputProvider } from 'contexts/EmailInputContext';
import ShipcampsLogo from 'images/shipcamps/shipcamps_logo_fullcolor.svg';

export default function ShipcampsLeadGenLandingPage() {

  return (
    <EmailInputProvider
    buttonText={'Submit'}
    >
      <ToastContainer />
      {/* Background image container with responsive height */}
      <div>
        <div className="px-7 pt-8 md:px-12 lg:px-16">
          <img
            src={ShipcampsLogo}
            alt="Ship Camps"
            className="w-28 md:w-[138px] h-auto"
          />
        </div>
        <HeroSection
          heading={
            <span className="text-[#000000]">Camps Season 2027 is Coming!</span>
          }
          subheading={
            <span className="text-[#000000] font-normal">
              <p>2027 registration opens in early February — sign up to be notified when registration is open.</p>
            </span>
          }
          buttonText="Submit"
          buttonBgColor="#000000"
        />
      </div>
    </EmailInputProvider>
  );
}
